import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import { FC } from "react";

export interface AuthMessageProps {
  message: string;
  buttonText: string;
  onButtonClick: () => void;
  isLoading: boolean | undefined;
  disableButton?: boolean;
}

const AuthMessage: FC<AuthMessageProps> = ({
  message,
  buttonText,
  onButtonClick,
  isLoading,
  disableButton,
}) => (
  <Box>
    <Stack mt={2} spacing={5}>
      <Typography variant="h2" sx={{ fontSize: "2.25rem", fontWeight: 300 }}>
        {message}
      </Typography>
      <Button
        onClick={onButtonClick}
        variant="contained"
        sx={{ width: "400px", fontWeight: 400, fontSize: "1rem" }}
        disabled={disableButton}
      >
        {buttonText}
        {isLoading && (
          <CircularProgress sx={{ color: "white", ml: 1 }} size={16} />
        )}
      </Button>
    </Stack>
  </Box>
);

export default AuthMessage;
